export const testIdFactory = {
	// Navigation
	navigationHomeLink: () => 'navigation-home-link',
	navigationPepperINCLink: () => 'navigation-pepperInc-link',
	navigationWhitePepperLink: () => 'navigation-whitePepper-link',
	navigationConstitutionLink: () => 'navigation-constitution-link',
	navigationFAQLink: () => 'navigation-faq-link',
	navigationFeedbackLink: () => 'navigation-feedback-link',
	navigationFeedbackButton: () => 'navigation-feedback-button',
	navigationMRPepperLink: () => 'navigation-mrPepper-link',
	announcementBarLink: () => 'announcement-bar-link',
	daoAnnouncementLink: () => 'dao-announcement-link',
	daoAnnouncementSubLink: (name: string) => `dao-announcement-${name}-link`,
	// Footer
	footerCopyAddressContainer: () => 'footer-copyAddress-container',
	footerPrivacyPolicyLink: () => 'footer-privacyPolicy-link',
	footerTermsAndConditionsLink: () => 'footer-termsAndConditions-link',
	footerCookiePolicyLink: () => 'footer-cookiePolicy-link',
	footerManagePreferencesLink: () => 'footer-managePreferences-link',
	// Wallet
	walletConnectButton: () => 'wallet-connect-button',
	walletDisconnectIconMobile: () => 'wallet-disconnect-iconMobile',
	walletNetworkChangeButton: () => 'wallet-networkChange-button',
	walletPopupButton: () => 'wallet-popup-button',
	// Home
	homeGetPepperButton: () => 'home-getPepper-button',
	homeStakeAndVoteButton: () => 'home-stakeAndVote-button',
	homeEnterPepperINCButton: () => 'home-enterPepperInc-button',
	homeAddPepperButton: () => 'home-addPepper-button',
	// Faq
	FAQCopyAddressContainer: () => 'faq-copyAddress-container',
	// PepperInc
	pepperConnectWalletButton: () => 'pepper-connectWallet-button',
	pepperStakeButton: () => 'pepper-stake-button',
	PepperUnstakeButton: () => 'pepper-unstake-button',
	pepperClaimButton: () => 'pepper-claim-button',
	pepperPollOptionButton: (statusAndNumber: string, optionNumber: number) =>
		`pepper-poll${statusAndNumber}Option${optionNumber.toString()}-button`,
	pepperVoteButton: (statusAndNumber: string) => `pepper-poll${statusAndNumber}Vote-button`,
	pepperStakeAndVoteButton: (statusAndNumber: string) => `pepper-poll${statusAndNumber}StakeAndVote-button`,
	pepperAmountFormInput: () => `pepper-amountForm-input`,
	pepperAmountFormButton: (buttonLabel: string) => `pepper-amountForm-${buttonLabel}Button`,
	pepperDisconnectButton: () => 'pepper-disconnect-button',
	// MrPepper - Poll
	adminPollCreateModalButton: () => 'adminPoll-createModal-button',
	adminPollConfirmCreationFormButton: () => 'adminPoll-confirmCreationForm-button',
	adminPollConfirmEditFormButton: () => 'adminPoll-confirmEditForm-button',
	adminPollUpdateModalButton: () => 'adminPoll-updateModal-button',
	adminPollDeleteButton: () => 'adminPoll-delete-button',
	adminPollDuplicateButton: () => 'adminPoll-duplicate-button'
}
